import { graphql } from '@/gql/generated'

export const UpdateUserProfileDocument = graphql(`
  mutation UpdateUserProfile($pk: Int!, $updates: user_profiles_set_input!) {
    update_user_profiles_by_pk(pk_columns: { id: $pk }, _set: $updates) {
      ...UserProfile
    }
  }
`)

export const InsertMediaDocument = graphql(`
  mutation InsertMedia($media: media_insert_input!) {
    insert_media_one(object: $media) {
      id
    }
  }
`)
